<template>
  <tbody>
    <tr>
      <td colspan="3">
        <div class="product-name">
          <p>
            <strong>{{ cartItem.label }}</strong>
          </p>
        </div>
      </td>
      <td></td>
    </tr>
    <tr>
      <td>
        <a class="product-image-link" :href="'/shop/' + cartItem.name">
          <img
            :src="cartItem.imagePath"
            class="product-image"
            :alt="cartItem.label"
          />
        </a>
      </td>
      <td class="product-price">
        <div>
          ${{ cartItem.totalProductPrice }} <small>{{ cart.currency }}</small>
          <small v-if="cartItem.period" :v-html="cartItem.periodCartText">
          </small>
        </div>

        <div
          v-if="cartItem.totalAddonPrice > 0"
          class="addon-description-wrapper"
        >
          <hr />
          <small>+ ${{ cartItem.totalAddonPrice }} {{ cart.currency }}</small>
          <small>
            <a
              class="addon-description-link"
              href="javascript:void(0)"
              data-toggle="tooltip"
              data-placement="top"
              :title="cartItem.addonDescription"
            >
              {{ cartItem.addonName }}
              <i class="fa fa-info-circle"></i>
            </a>
          </small>
        </div>
      </td>
      <td class="cart-item-quantity-td">
        <cart-item-quantity
          :cart-item-index="cartItemIndex"
        ></cart-item-quantity>
      </td>
      <td>
        ${{ cartItem.subTotal }} <small>{{ cart.currency }}</small>
      </td>
    </tr>
    <tr>
      <td colspan="4">
        <cart-item-test-drives
          v-if="cartItem.testDriveSubscribers.length > 0"
          :cart-item-index="cartItemIndex"
        ></cart-item-test-drives>
      </td>
    </tr>
    <tr>
      <td colspan="4">
        <div class="product-name">
          <p>
            <small v-html="cartItem.description"></small>
          </p>
        </div>
      </td>
    </tr>
    <tr>
      <td colspan="4"></td>
    </tr>
  </tbody>
</template>
<script>
import { mapState } from "vuex";
import store from "../../store/stores";
import CartItemQuantity from "./CartItemQuantity.vue";
import CartItemTestDrives from "./CartItemTestDrives.vue";

export default {
  name: "ItemTableRows",
  components: { CartItemQuantity, CartItemTestDrives },
  store,
  props: {
    cartItem: {
      type: Object,
      required: true,
    },
    cartItemIndex: {
      type: Number,
      default: null,
    },
  },
  computed: {
    ...mapState(["cart"]),
  },
};
</script>

<style scoped>
.cart-item-quantity-td {
  width: 280px;
}
</style>
